import clsx from "clsx";

interface CheckProps {
  showCheck?: boolean;
  showActive?: boolean;
}

const Check = ({ showCheck = true, showActive = true }: CheckProps) => {
  const checkClasses = clsx({
    "fa-solid": true,
    "fa-regular": !showCheck,
    "fa-circle-check": true,
    "fa-circle": !showCheck,
    "text-primary": true,
    "text-neutral-500": !showActive,
    "fa-lg": true,
  });
  return <i data-component="Check" className={checkClasses}></i>;
};

export default Check;
